import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef, ICellRendererParams } from "ag-grid-enterprise";
import { Addition } from "../../../../models/eaf.models";
import { EditAndDeleteButtons } from "../../components/EditAndDeleteButtons";
import { ManualAutoButton } from "../../components/ManualAutoButton";

type Props = {
	deleteAddition: (additionId: number) => void;
	editAddition: (additionId: number) => void;
};

export const useTableData = ({ deleteAddition, editAddition }: Props) => {
	const columns: ColGroupDef[] = [
		{
			headerName: "Material Additions",
			headerStyle: {
				fontSize: "0.9rem",
			},
			children: [
				{
					field: "manual-auto",
					headerName: " ",
					flex: 1,
					minWidth: 50,
					maxWidth: 50,
					cellRenderer: ManualAutoButton,
					cellRendererParams: (params: ICellRendererParams) => ({
						isManual: (params.data as Addition).IsAdditionManual,
					}),
				},
				{
					field: "Timestamp",
					headerName: "Time",
					flex: 1,
					minWidth: 62,
					valueGetter: (params: any) => {
						if (params.data.Timestamp) {
							return dxtToLocalServerTime(
								(params.data as Addition).Timestamp,
								"HH:mm",
							);
						}
					},
				},
				{
					field: "MaterialName",
					headerName: "Material",
					flex: 1,
					minWidth: 100,
				},
				{
					field: "Weight",
					headerName: "Weight [kg]",
					flex: 1,
					minWidth: 102,
					cellStyle: {
						textAlign: "right",
					},
					valueGetter: (params: any) => {
						if (params.data.Weight) {
							return Math.floor((params.data as Addition).Weight);
						}
					},
				},
				{
					field: "actions",
					headerName: " ",
					flex: 1,
					minWidth: 60,
					maxWidth: 80,
					cellRenderer: EditAndDeleteButtons,
					cellRendererParams: (params: ICellRendererParams) => ({
						deleteItem: deleteAddition,
						edit: editAddition,
						id: (params.data as Addition).AdditionId,
					}),
				},
			],
		},
	];

	const defaultColDef: ColDef = {
		filter: false,
		floatingFilter: false,
		sortable: false,
		resizable: false,
		editable: false,
	};

	return { columns, defaultColDef };
};
